import { render, staticRenderFns } from "./productInfoDialog.vue?vue&type=template&id=0633844a&scoped=true&"
import script from "./productInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./productInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./productInfoDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productInfoDialog.vue?vue&type=style&index=1&id=0633844a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633844a",
  null
  
)

export default component.exports